(function (window, upp) {
    'use strict';

    const gmapsProvider = (() => {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + window.$UPP.GOOGLE_MAPS_KEY;
            script.async = true;
            script.onload = () => {
                resolve(window.google.maps);
            };
            script.onerror = () => reject(new Error(`Couldn't load cordova runtime at ${script.src}`));
            document.getElementsByTagName('head')[0].appendChild(script);
        })
    })();

    const onGoogleMapsLoad = (cb) => {
        gmapsProvider.then((gmaps) => cb(gmaps));
    };

    upp.directive('googleMap', [ function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            templateUrl: require('../templates/google-map-directive.html'),
            controller: ['$scope', function ($scope) {
                onGoogleMapsLoad((gmaps) => {
                    // It's the only way to get the index of the current map and use it with the google maps api
                    var index = $scope.$index;

                    var lat = $scope.loc.lat,
                        lng = $scope.loc.lng,
                        mapOptions = {
                            zoom: 15,
                            center: new gmaps.LatLng(lat, lng)
                        },
                        map = new gmaps.Map(document.getElementsByClassName('map-canvas')[index],
                            mapOptions),

                        marker = new gmaps.Marker({
                            position: map.getCenter(),
                            map: map
                        });

                    marker.setMap(map);

                    $scope.updateCoordinates = function (lat, lng, url) {
                        $scope.loc.lat = lat;
                        $scope.loc.lng = lng;
                        $scope.loc.url = url;

                        marker.setPosition(new gmaps.LatLng(lat, lng));
                        map.setZoom(17);
                        map.setCenter(marker.getPosition());
                    };
                })
            }]
        }
    }]);
}(window, upp));



// WEBPACK FOOTER //
// ./src/app/modules/about/directives/google-map-directive.js